module.exports = __webpack_public_path__ + "img/15.e6b5b25f.png";